var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCourseMorning(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 0c.301 0 .546.244.546.545v1.091a.546.546 0 0 1-1.091 0V.546c0-.302.244-.546.545-.546zm12 12.546a.545.545 0 0 1-.546.545h-1.09a.545.545 0 0 1 0-1.091h1.09c.302 0 .546.244.546.546zm-11.454 9.818a.546.546 0 0 0-1.091 0v1.09a.546.546 0 0 0 1.09 0v-1.09zM2.181 12a.546.546 0 0 1-.546.546H.546a.546.546 0 0 1 0-1.091h1.09c.302 0 .546.244.546.545zm2.104-8.485a.545.545 0 0 0-.771.771l.771.772a.545.545 0 1 0 .772-.772l-.772-.771zm16.188.007a.545.545 0 0 1 0 .771l-.771.772a.545.545 0 0 1-.772-.772l.772-.771a.545.545 0 0 1 .77 0zm-.76 15.42a.545.545 0 0 0-.771.772l.77.771a.545.545 0 0 0 .772-.771l-.771-.771zm-14.657 0a.545.545 0 0 1 0 .772l-.77.771a.545.545 0 0 1-.772-.771l.771-.771a.545.545 0 0 1 .771 0zM4.91 12a7.09 7.09 0 1 1 14.182 0 7.09 7.09 0 0 1-14.182 0zM12 3.818a8.182 8.182 0 1 0 0 16.364 8.182 8.182 0 0 0 0-16.364z",
    fill: "#FF062E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCourseMorning);
export default __webpack_public_path__ + "static/media/CourseMorning.b98e8ef2a7aa49d99cd6212d71698709.svg";
export { ForwardRef as ReactComponent };